import { Component, OnInit } from '@angular/core';
import { ComponentBase } from 'src/app/main/dynamic/component-base';
import { AttributeModel } from 'src/app/main/dynamic/model/attribute.model';

@Component({
  selector: 'app-input-decimal',
  templateUrl: './input-decimal.component.html',
  styleUrls: ['./input-decimal.component.scss']
})
export class InputDecimalComponent extends ComponentBase implements OnInit {

  constructor() { super() }

  ngOnInit() {
    if (this.attribute.value == '')
      this.attribute.value = null;
  }

  getOptionValue(parentAttr: AttributeModel, optionKey: string, defaultValue?: string): string {
    if (!parentAttr.options)
      return null;

    let attribute = parentAttr.options.find(option => option.key == optionKey);

    if (attribute != undefined)
      return attribute.value;
    else if (defaultValue != null)
      return defaultValue;
    else
      return "false";
  }
}
